var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8717 12.2758C23.8717 11.46 23.8056 10.6399 23.6645 9.8374H12.3457V14.4584H18.8274C18.5585 15.9487 17.6942 17.2671 16.4287 18.1049V21.1032H20.2957C22.5665 19.0132 23.8717 15.9267 23.8717 12.2758Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3457 23.9998C15.5821 23.9998 18.3115 22.9372 20.3001 21.1029L16.4331 18.1046C15.3573 18.8365 13.9683 19.251 12.3501 19.251C9.21947 19.251 6.56505 17.1389 5.61264 14.2993H1.62219V17.3903C3.6593 21.4424 7.80849 23.9998 12.3457 23.9998Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60824 14.2992C5.10558 12.8089 5.10558 11.1951 5.60824 9.70471V6.61377H1.62221C-0.0797975 10.0045 -0.0797975 13.9994 1.62221 17.3902L5.60824 14.2992Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3457 4.74868C14.0565 4.72223 15.71 5.36599 16.949 6.54769L20.3751 3.12164C18.2057 1.08453 15.3264 -0.0354426 12.3457 -0.000167897C7.80849 -0.000167897 3.6593 2.55725 1.62219 6.61383L5.60823 9.70477C6.55624 6.86075 9.21506 4.74868 12.3457 4.74868Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5238,
    height: 24,
    fill: "white",
    transform: "translate(0.3479)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c721b1db0a23276fa649392a74f834b8.svg";
export { ForwardRef as ReactComponent };